import React from 'react';
import clsx from 'clsx';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import ItecDialog from '../../../modules/checkListGenerator/itechChecklist/itechAddRelevancePopUp';
import useStyles from './assetStyle';

function StyledRadio(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [country, setCountry] = React.useState('Enter Country');

    // const handleChange = (event) => {
    //     setCountry(event.target.value);
    // };

    // const handleClose = () => {
    //     setOpen(false);
    // };

    // const handleOpen = () => {
    //     setOpen(true);
    // };

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function ItechForeignAssetsHome() {
    const classes = useStyles();
    const [itecOpen, setItecOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [country, setCountry] = React.useState('Enter Country');

    const handleChange = (event) => {
        setCountry(event.target.value);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };
    const handleRelevence = () => {
        //console.log('handleRele++++');
        setItecOpen(true);
    };
    const handleItecClose = () => {
        setItecOpen(false);
    };

    const [formValues, setFormValues] = React.useState({
        country: 'Enter Country Name',
        tpin: 'Enter Taxpayer Identification number',
        salA: 'Enter Income',
        salB: 'Enter Income',
        salC: 'Enter Income',
        salD: 'Enter Income',
        salE: 'Enter Income',
        srcNature: 'Enter Income',
        totIncome: 'Enter Total Income',
        incomeNature: 'Enter Nature of income',
        foreignAmount: 'Enter Amount',
        foreignTaxes: 'Enter Taxes paid',
    });

    return (
        <>
            <div className="main-container">
                <FormControl component="fieldset">
                    <RadioGroup defaultValue="yes" aria-label="asset" name="customized-radios" className="radio-option">
                        <ul className="makeStyles-inlineDisplay-111">
                            <li>
                                <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                            </li>
                            <li>
                                <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                            </li>
                        </ul>
                    </RadioGroup>
                </FormControl>

                <Typography style={{ paddingTop: '20px' }}>
                    Please enter the details in this sheet in the respective currency and provide us with any documentary proof available
                    for any of them
                </Typography>
                <Typography>
                    (Applicable only for residents in India having foreign assets & incomes. Not applicable for Non residents)
                </Typography>

                <Grid container>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className="mb15 mt15"
                        style={{ fontWeight: '500', color: '#4c4c4d', fontSize: '15px' }}
                    >
                        Details of Income accruing or arising outside India
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="country-name">
                                    Country Name
                                </InputLabel>
                                <Select
                                    disabled
                                    id="country-name"
                                    className={classes.bottomLine}
                                    value={country}
                                    open={open}
                                    onClose={handleClose}
                                    onOpen={handleOpen}
                                    onChange={handleChange}
                                    IconComponent={() => <FontAwesomeIcon icon={faAngleDown} />}
                                >
                                    <MenuItem value="Enter Country">Enter Country</MenuItem>
                                    <MenuItem value="India">India</MenuItem>
                                    <MenuItem value="Nepal">Nepal</MenuItem>
                                    <MenuItem value="Sri Lanka">Sri Lanka</MenuItem>
                                </Select>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="tpin">
                                    Taxpayer Identification number in the respective country
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="tpin" value={formValues.tpin} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="sal-a">
                                    Income from salary (A)
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="sal-a" value={formValues.salA} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="sal-b">
                                    Income from house property (B)
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="sal-b" value={formValues.salB} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="sal-c">
                                    Business Income (C)
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="sal-c" value={formValues.salC} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="sal-d">
                                    Capital gains income (D)
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="sal-d" value={formValues.salD} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="sal-e">
                                    Other income (Interest, Dividend etc) (E)
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="sal-e" value={formValues.salE} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="srcNature">
                                    Specify nature of the source income
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="srcNature" value={formValues.srcNature} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={12} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="totIncome">
                                    Total income from outside India(F)= A+B+C+D+E
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="totIncome" value={formValues.totIncome} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* <div className="text-left">
                    <Button variant="outlined" color="primary" className="txt-capitalize">
                        Add More
                    </Button>
                </div> */}
                </Grid>

                <Grid container>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className="mb15 mt15"
                        style={{ fontWeight: '500', color: '#4c4c4d', fontSize: '15px' }}
                    >
                        Details of taxes paid on the above incomes in the respective countries
                    </Typography>
                    <Grid container spacing={2} style={{ justifyContent: 'space-between', paddingTop: '30px' }}>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="income-nature">
                                    Nature of income
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="income-nature" value={formValues.incomeNature} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="foreign-amount">
                                    Amount (in foreign currency)
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="foreign-amount" value={formValues.foreignAmount} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} sm={6} className={classes.marginBtm}>
                            <FormControl fullWidth>
                                <InputLabel className={classes.inLabel} htmlFor="foreign-taxes">
                                    Taxes paid (in foreign currency)
                                </InputLabel>
                                <Input disabled className={classes.bottomLine} id="foreign-taxes" value={formValues.foreignTaxes} />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* <div className="text-left">
                    <Button variant="outlined" color="primary" className="txt-capitalize">
                        Add More
                    </Button>
                </div> */}
                </Grid>
            </div>
            {itecOpen && <ItecDialog itecOpen={itecOpen} handleItecClose={handleItecClose} />}
        </>
    );
}
